'use strict';

angular.module('msCommunity').directive('msFlaggingOptions', [function () {
  return {
    templateUrl: 'community/templates/flagging-options.html',
    restrict: 'E',
    bindToController: true,
    controller: 'FlaggingOptionsCtrl',
    controllerAs: 'vm'
  };
}]).controller('FlaggingOptionsCtrl', ['eventTrackingSvc', 'discussionSvc', 'NotifyingSvc', '$scope', function (eventTrackingSvc, discussionSvc, NotifyingSvc, $scope) {
  this.$onInit = function () {
    var vm = this;
    vm.comment = $scope.dataModel;
    vm.flagged = false;

    vm.flag = function (comment, flag) {
      discussionSvc.flag(comment.id, flag).then(function () {
        eventTrackingSvc.fireEvent('community', 'toggleFlag', flag, { comment: comment.id, flag: flag });
        vm.flagged = true;
        $scope.callback();
        NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.OPTIN_UPDATE);
      });
    };
  };
}]);